export interface EditableItem<T> {
    item: T;
    editedItem: T;
    isEdited?: boolean;
}

export class EditableItem<T> implements EditableItem<T> {
    item!: T;

    editedItem!: T;

    isEdited?: boolean;

    constructor(item: T, editedItem: T, isEdited: boolean) {
        this.item = item;
        this.editedItem = editedItem;
        this.isEdited = isEdited;
    }
}